<template>
    <div class="animated fadeIn">
        <div class="card" style="margin:0px 15px 10px 15px">
            <div class="row" style="padding: 20px;background-color:#fff">
                <div class="col-md-8">
                    <p style="font-size: 16px;">This pages shows the details of a loan contract</p>
                </div>
                <div class="col-md-4">
                    <p class="text-right">
                        <b-link v-show="!loading" @click="goBack()">
                            <span class="fa fa-arrow-left"></span> Return Back
                        </b-link>
                    </p>
                </div>
            </div>
        </div>
        <b-row>
            <b-col cols="12" lg="12">
                <p v-if="loading" style="text-align: center;padding: 20px">
                    <span style="font-size: 25px;">
                        <i class="fa fa-spinner fa-spin"></i> Loading...
                    </span>
                </p>
                <div v-else>
                    
                        <b-card :header="` Details`"> 
                            <b-row>
                                <b-col lg="3" md="3" sm="12" xs="12">
                                    <p class="text-center" title="Click to change photo">
                                        <img v-if="userDetails.profile_image === null" src="../../assets/images/man.png" alt="profile-image" />
                                        <img v-else-if="profile_image !== ''" :src="profile_image" alt="profile-image" class="rounded-circle img-response" width="150"/>
                                        <img v-else src="../../assets/images/man.png" alt="profile-image" />
                                    </p><hr/>
                                    <b-list-group>
                                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                                            <strong>Name:</strong>
                                            <strong>{{`${userDetails.first_name} ${userDetails.last_name}`}}</strong>
                                        </b-list-group-item>
                                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                                            <strong>Status:</strong>
                                            <b-badge v-if="userDetails.is_active === 1" variant="success" pill>Active</b-badge>
                                            <b-badge v-else variant="warning" pill>Inactive</b-badge>
                                        </b-list-group-item>
                                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                                            <strong>Contract Status</strong>
                                            <b-badge variant="warning" v-if="loanDetail.loan_status_id === 1" pill>Pending</b-badge>
                                            <b-badge variant="primary" v-else-if="loanDetail.loan_status_id === 2" pill>Awaiting Approval</b-badge>
                                            <b-badge variant="success" v-else-if="loanDetail.loan_status_id === 3" pill>Accepted</b-badge>
                                            <b-badge variant="primary" v-else-if="loanDetail.loan_status_id === 4" pill>Awaiting Disbursement</b-badge>
                                            <b-badge variant="danger" v-else-if="loanDetail.loan_status_id === 6" pill>Declined</b-badge>
                                            <b-badge variant="success" v-else-if="loanDetail.loan_status_id === 5" pill>Disbursed</b-badge>
                                        </b-list-group-item>
                                    </b-list-group><br/>
                                    <button class="btn btn-md btn-primary form-control" @click="viewCustomerDetails">View Customer Profile</button><br/><br/>
                                    <button class="btn btn-md btn-warning form-control" @click="viewCustomerRedflags">Red Flag Statistics</button>
                                </b-col>
                                <b-col lg="9" md="9" sm="12" xs="12">
                                    <form @submit.prevent="onUpdateLoan">
                                        <b-card header="Contract Information">
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Contract Type" label-for="normalPass">
                                                        <select class="form-control" disabled>
                                                            <option v-if="loan_type === 1">Private Sector Loan</option>
                                                            <option v-else-if="loan_type === 2">Public Sector Loan</option>
                                                            <option v-else>Business Loan</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Loan Reason" label-for="normalEmail">
                                                        <select class="form-control" v-model="reason" disabled>
                                                            <option selected>{{reason}}</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Loan Duration" label-for="normalPass">
                                                        <select class="form-control" v-model="loan_duration" :required="true">
                                                            <option value="">--select--</option>
                                                            <option v-for="(duration, index) in durations" v-bind:key="index" :value="duration">{{duration}} Months</option>
                                                        </select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Interest Rate(%)" label-for="normalPass">
                                                        <b-form-input v-model="interest_rate" type="number"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="12" xs="12">
                                                    <b-form-group label="Admin Fee(₦)" label-for="normalPass">
                                                        <b-form-input v-model="admin_fee" type="number"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Loan Amount(₦)" label-for="normalPass">
                                                        <b-form-input v-model="amount" type="number"></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Application Date" label-for="normalEmail">
                                                        <b-form-input v-model="application_date" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Reference Number" label-for="normalEmail">
                                                        <b-form-input v-model="reference_number" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row><br/>
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Loan ID" label-for="normalPass">
                                                        <b-form-input v-model="loan_number" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Disbursed By" label-for="normalEmail">
                                                        <b-form-input v-model="disbursed_by" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <b-form-group label="Date of Disbursement" label-for="normalEmail">
                                                        <b-form-input v-model="date_of_disbursement" type="text" disabled></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row><hr/>
                                            <div v-if="access.includes(role)">
                                                <b-button-group v-if="loanDetail.loan_status_id === 1 || loanDetail.loan_status_id === 2 || loanDetail.loan_status_id === 3">
                                                    <b-button type="button" variant="success" v-if="loading" disabled>
                                                        <i class="fa fa-spinner fa-spin"></i> 
                                                        Updating...
                                                    </b-button>
                                                    <b-button type="submit" variant="success" v-else>
                                                        <i class="fa fa-cog"></i> 
                                                        Update Contract
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-card><br/>
                                        <b-card  v-if="this.repayments.length > 0" header="Repayment Schedule">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>S/N</th>
                                                        <th>Amount(₦)</th>
                                                        <th>Date</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(repayment, index) in this.repayments[0]" v-bind:key="index">
                                                        <td>{{++index}}</td>
                                                        <td>₦{{repayment.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</td>
                                                        <td>{{repayment.date}}</td>
                                                        <td>
                                                            <b-badge variant="success" v-if="repayment.status === 1" pill>Paid</b-badge>
                                                            <b-badge variant="warning" v-else-if="repayment.status === 0" pill>Not Paid</b-badge>
                                                        </td>
                                                        <td>
                                                            <b-button-group v-if="repayment.status === 0 && access_2.includes(role)">
                                                                <b-button @click="markAsPaid(index)" variant="success" :disabled="loanDetail.loan_status_id !== 5">
                                                                    <i class="fa fa-check"></i> Mark As Paid
                                                                </b-button>
                                                            </b-button-group>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-card><br/>
                                    </form>
                                    <b-card v-if="this.customerDetails.business_name === null" header="Contract Documents">
                                        <div v-if="this.customerDetails.employer_sector === 'private'">
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${loanDetail.employment_letter}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Employment Letter<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.emploment_letter === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${this.loanDetail.bank_statement}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Bank Statement<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.bank_statement === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${loanDetail.utility_bill}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Utility Bill<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.utility_bill === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${loanDetail.valid_means_of_id}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Valid ID<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.valid_means_of_id === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${loanDetail.work_id}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Work ID<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.work_id === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                            </b-row>
                                        </div>

                                        <div v-else-if="this.customerDetails.employer_sector === 'public'">
                                            <b-row>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${this.loanDetail.bank_statement}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Bank Statement<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.bank_statement === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${loanDetail.valid_means_of_id}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Valid ID<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.valid_means_of_id === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                                <b-col lg="4" md="4" sm="12" xs="12">
                                                    <a :href="`${url}${loanDetail.payslips}`" target="_blank">
                                                        <p class="text-center doc" title="Click to view">
                                                            <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                            Payslips<br/>
                                                            <b-badge variant="danger" v-if="loanDetail.payslips === null" pill>Not uploaded</b-badge>
                                                            <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                        </p>
                                                    </a>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-card>
                                    <b-card v-else header="Business Contract Documents">
                                        <b-row>
                                            <b-col lg="4" md="4" sm="12" xs="12">
                                                <a :href="`${url}${this.loanDetail.bank_statement}`" target="_blank">
                                                    <p class="text-center doc" title="Click to view">
                                                        <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                        Bank Statement<br/>
                                                        <b-badge variant="danger" v-if="loanDetail.bank_statement === null" pill>Not uploaded</b-badge>
                                                        <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                    </p>
                                                </a>
                                            </b-col>
                                            <b-col lg="4" md="4" sm="12" xs="12">
                                                <a :href="`${url}${loanDetail.utility_bill}`" target="_blank">
                                                    <p class="text-center doc" title="Click to view">
                                                        <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                        Utility Bill<br/>
                                                        <b-badge variant="danger" v-if="loanDetail.utility_bill === null" pill>Not uploaded</b-badge>
                                                        <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                    </p>
                                                </a>
                                            </b-col>
                                            <b-col lg="4" md="4" sm="12" xs="12">
                                                <a :href="`${url}${loanDetail.valid_means_of_id}`" target="_blank">
                                                    <p class="text-center doc" title="Click to view">
                                                        <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                        Valid ID<br/>
                                                        <b-badge variant="danger" v-if="loanDetail.valid_means_of_id === null" pill>Not uploaded</b-badge>
                                                        <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                    </p>
                                                </a>
                                            </b-col>
                                            <b-col lg="4" md="4" sm="12" xs="12">
                                                <a :href="`${url}${loanDetail.certificate_of_corporation}`" target="_blank">
                                                    <p class="text-center doc" title="Click to view">
                                                        <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                        Certificate of Corporation<br/>
                                                        <b-badge variant="danger" v-if="loanDetail.certificate_of_corporation === null" pill>Not uploaded</b-badge>
                                                        <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                    </p>
                                                </a>
                                            </b-col>
                                            <b-col lg="4" md="4" sm="12" xs="12">
                                                <a :href="`${url}${loanDetail.other_documents}`" target="_blank">
                                                    <p class="text-center doc" title="Click to view">
                                                        <img src="../../assets/images/file.png" class="img-responsive"/><br/>
                                                        Other Business Document<br/>
                                                        <b-badge variant="danger" v-if="loanDetail.other_documents === null" pill>Not uploaded</b-badge>
                                                        <b-badge variant="success" v-else pill>Uploaded</b-badge>
                                                    </p>
                                                </a>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </b-col>
                            </b-row><hr/>
                            <div class="pull-right">
                                <div v-if="access.includes(role)">
                                    <b-button-group v-if="loanDetail.loan_status_id === 1">
                                        <div v-if="pending_loading || decline_loading">
                                            <b-button variant="success" disabled><i class="fa fa-spinner fa-spin"></i> Please wait ...</b-button>
                                        </div>
                                        <div v-else>
                                            <b-button @click="onApproveLoan" variant="success"><i class="fa fa-check"></i> Approve</b-button>
                                            <b-button @click="onDeclineLoan" variant="danger"><i class="fa fa-close"></i> Decine</b-button>
                                        </div>
                                    </b-button-group>
                                    <b-button-group v-else-if="loanDetail.loan_status_id === 2">
                                        <b-button variant="primary" disabled><i class="fa fa-refresh fa-spin"></i> Awaiting customer's acknowledgement</b-button>
                                    </b-button-group>
                                    <b-button-group v-else-if="loanDetail.loan_status_id === 3">
                                        <b-button variant="success" @click="approveDisburse"><i class="fa fa-check"></i> Approve for disbursement</b-button>
                                    </b-button-group>
                                    <b-button-group v-else-if="loanDetail.loan_status_id === 4">
                                        <div v-if="disbursing">
                                            <b-button variant="success" disabled><i class="fa fa-spinner fa-spin"></i> Please wait ... </b-button>
                                        </div>
                                        <div v-else>
                                            <b-button variant="success" @click="loanDisburse"><i class="fa fa-check"></i> Disburse Now</b-button>
                                        </div>
                                    </b-button-group>
                                    <b-button-group v-else-if="loanDetail.loan_status_id === 5">
                                        <b-button variant="success" disabled><i class="fa fa-check"></i> Disbursed</b-button>
                                    </b-button-group>
                                    <b-button-group v-else-if="loanDetail.loan_status_id === 6">
                                        <b-button variant="success" @click="resetApplication"><i class="fa fa-refresh"></i> Reset Application</b-button>
                                        <b-button variant="danger" disabled><i class="fa fa-check"></i> Loan Declined</b-button>
                                    </b-button-group>
                                </div>
                            </div>
                        </b-card>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { baseURL, URL } from '../../shared/utils';
import { userDetails } from '@/services/userService';
import { loanDetails, loanApproval, loanTypes, loanReasons, disburse } from '@/services/loanService';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'loandetails',
    data() {
        return {
            loan_reason: null,
            loan_type: null,
            pending_loading: false,
            loanDetail: {},
            repayments: [],
            types: [],
            reasons: [],
            customerDetails: {},
            userDetails: {},
            loan_duration: null,
            application_date: '',
            reference_number: '',
            admin_fee: 0,
            interest_rate: 0.00,
            amount: 0,
            loading: false,
            url: URL,
            durations: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
            profile_image: '',
            disbursed_by: null,
            date_of_disbursement: null,
            disbursing: false,
            loan_number: null,
            role: '',
            access: ['administrator','risk'],
            access_2: ['administrator','risk','collection and recovery']
        }
    },
    computed: {
        reason: function() {
            let data;
            this.reasons.map(reason => {
                if(reason.id === this.loan_reason) {
                    data = `${reason.name}`;
                }
            });

            return data;
        },
        ...mapState([
            'user',
            'roles',
            'loanTypes',
            'loanReasons',
        ])
    },
    async beforeMount() {
        this.role = this.roles[0].name;
        this.getLoanTypes();
        this.getLoanReasons();
    },
    created() {
        const loan_id = this.$route.params.id;
        this.getLoan(loan_id);
    },
    methods: {
        ...mapActions([
            'updateLoan',
            'approveLoan',
            'updateRepayment',
            'disburseLoan'
        ]),
        goBack() {
            this.$router.go(-1);
        },
        async getLoan(id) {
            this.loading = true;
            try {
                const {data:{loan}} = await loanDetails(id);
                const {user_id, customer_id} = loan;

                this.getUserDetails(user_id);
                this.amount = loan.amount;
                this.loan_reason = loan.loan_reason_id;
                this.loan_type = loan.loan_type_id;
                this.loan_duration = loan.loan_duration;
                this.application_date = loan.application_date;
                this.reference_number = loan.reference;
                this.disbursed_by = loan.disbursed_by;
                this.date_of_disbursement = loan.date_of_disbursement;
                this.loan_number = loan.loan_number;

                this.filterRepayment(loan.loan_repayments);
                this.loanDetail = loan;
                
            } catch(err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
        async getLoanTypes() {
            try {
                const {data} = await loanTypes();
                this.types = data.datas.data;
            }
            catch(err) {}
        },
        async getLoanReasons() {
            try {
                const {data} = await loanReasons();
                this.reasons = data.datas.data;
            }
            catch(err) {}
        },
        filterRepayment(datas) {
            const repayments = datas.map(data => data.data);
            this.repayments = repayments;
        },
        async getUserDetails(id) {
            try {
                const { data: { user } } = await userDetails(id);
                this.userDetails = user;
                this.profile_image = `${URL}${user.profile_image}`;
                this.customerDetails = user.customer;
                this.getLoanReasons(user.customer.business_name);
            } catch (error) {}
        },
        async onUpdateLoan() {
            try {
                const loan_id = this.$route.params.id;
                const payload = {
                    loan_reason_id: this.loan_reason,
                    loan_type_id: this.loan_type,
                    loan_duration: this.loan_duration,
                    amount: this.amount,
                    interest: this.interest_rate,
                    admin_fee: this.admin_fee,
                    id: loan_id
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to update this loan?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, update it!'
                }).then(async (result) => {
                    if (result.value) {
                        const response = await this.updateLoan({payload: payload, id:loan_id});
                        if (response) {
                            this.$swal('Updated Successfully!','Customer loan contract has been updated.','success');
                            window.location.reload();
                        }
                    }
                });
            }
            catch(err) {
                console.log(err);
            }
        },
        markAsPaid(key) {
            const index = key === 0 ? key : --key;
            this.$swal({
                title: 'Are you sure?',
                text: "Are you sure you want to mark this repayment?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!'
            }).then(async (result) => {
                if (result.value) {
                    const loan_id = this.$route.params.id;
                    const check = await this.updateRepayment({key:index,loan_id:loan_id});
                    if (check) {
                        this.$swal('Done!','This repayment has been marked as paid.','success');
                        window.location.reload();
                    }
                }
            });
        },
        viewCustomerDetails() {
            this.$router.push(`/customers/${this.loanDetail.customer_id}`)
        },
        viewCustomerRedflags() {
            this.$router.push(`/customers/red-flags/${this.userDetails.id}`)
        },
        onApproveLoan() {
            this.$swal({
                title: 'Are you sure?',
                text: "Are you really sure you want to approve this loan request?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!'
            }).then(async (result) => {
                if (result.value) {
                    this.pending_loading = true;
                    try {
                        const loan_id = this.$route.params.id;
                        const {data:{loan}} = await loanApproval(2, loan_id);
                        this.loanDetails = loan;
                        this.$swal('Approved Successfully!','You have successfully approve this facility.','success');
                        window.location.reload();
                    } catch(err) {
                        console.log(err);
                    }
                    finally {
                        this.pending_loading = false;
                    }
                }
            })
        },
        onDeclineLoan() {
            this.$swal({
                title: 'Are you sure?',
                text: "Are you sure you want to decline this request?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, decline!'
            }).then(async (result) => {
                if (result.value) {
                    this.pending_loading = true;
                    try {
                        const loan_id = this.loanDetail.id;
                        const { data: { loan } } = await loanApproval(6, loan_id);
                        this.loanDetails = loan;
                        this.$swal('Declined Successfully!','This facility has been declined.','success');
                        window.location.reload();
                    } catch(err) {
                        console.log(err);
                    }
                    finally {
                        this.pending_loading = false;
                    }
                }
            })
        },
        approveDisburse() {
            this.$swal({
                title: 'Are you sure?',
                text: "Are you sure you want to add this loan contract on disbursement list?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, add please!'
            }).then(async (result) => {
                if (result.value) {
                    this.pending_loading = true;
                    try {
                        const loan_id = this.loanDetail.id;
                        const { data: { loan } } = await loanApproval(4, loan_id);
                        this.loanDetails = loan;
                        this.$swal('Added Successfully!','This loan request has been approved for disbursement!','success');
                        window.location.reload();
                    } catch(err) {
                        console.log(err);
                    }
                    finally {
                        this.pending_loading = false;
                    }
                }
            })
        },
        resetApplication() {
            this.$swal({
                title: 'Are you sure?',
                text: "You are about to reset this loan application?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, reset it!'
            }).then(async (result) => {
                if (result.value) {
                    this.pending_loading = true;
                    try {
                        const loan_id = this.loanDetail.id;
                        const { data: { loan } } = await loanApproval(1, loan_id);
                        this.loanDetails = loan;
                        this.$swal('Reset Successfully!','This loan request has been successfully','success');
                        window.location.reload();
                    } catch(err) {
                        console.log(err);
                    }
                    finally {
                        this.pending_loading = false;
                    }
                }
            })
        },
        checkRecipient() {
            const check = this.customerDetails.recipient_code;
            if (check === null) {
                this.$swal('No Recipient Code','This is customer does not have a recipient code. Go to customer profile to generate a recipient code.','error');
                return false;
            }

            return true;
        },
        async loanDisburse(id) {
            this.$swal({
                title: 'You are about to disburse?',
                text: "Are you sure you want to disburse this amount to the customer?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, disburse please!'
            }).then(async (result) => {
                if (result.value) {
                    if (this.checkRecipient()) {
                        this.disbursing = true;
                        try {
                            const loan_id = this.loanDetail.id;
                            const { data } = await disburse(loan_id);
                            if (data.success) {
                                this.$swal('Disbursed Successfully.', 'This facility has been placed on disbursement queue sucessfully.', 'success');
                                window.location.reload();
                            }
                        } catch(err) {
                            const { status, data, statusText } = err.response;
                            if (status === 400) {
                                this.$swal(statusText,data.message,'error');
                            }
                        }
                        finally {
                            this.disbursing = false;
                        }
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
    .doc {
        opacity: 0.6;
        cursor: pointer;
        font-size: 16px;
    }

    .doc:hover {
        opacity: 0.9;
    }
</style>
